export const INVITE_ACCEPTED = 'accepted';
export const INVITE_FAILED = 'failed';
